import { c as _c } from "react/compiler-runtime";
import { SelectRole } from "@components/role/select-role";
import { FaroCoreApiConst } from "@stellar/core-api-client";
/** The entry that removes a member from the project */
const REMOVE_FROM_PROJECT = "Remove from project";

/**
 * Renders a dropdown to select a project role, with a description of each role and optionally an
 * entry to remove the member from the project.
 */
export function SelectProjectRole(t0) {
  const $ = _c(21);
  const {
    selectedRole,
    onChange,
    variant,
    disabledRoles: t1,
    menuProps,
    isRoleEditable: t2,
    onRemove,
    isDisabled
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const disabledRoles = t3;
  const isRoleEditable = t2 === undefined ? true : t2;
  let t4;
  if ($[2] !== onChange) {
    t4 = function onSelectRoleChange(role) {
      onChange(role);
    };
    $[2] = onChange;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const onSelectRoleChange = t4;
  let t5;
  if ($[4] !== onRemove) {
    t5 = onRemove ? {
      label: REMOVE_FROM_PROJECT,
      onRemove
    } : undefined;
    $[4] = onRemove;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const removeOption = t5;
  let t6;
  if ($[6] !== isRoleEditable || $[7] !== selectedRole) {
    t6 = isRoleEditable || !selectedRole ? FaroCoreApiConst.allProjectRoles : [selectedRole];
    $[6] = isRoleEditable;
    $[7] = selectedRole;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = ["RESOURCE_OWNER"];
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== disabledRoles) {
    t8 = t7.concat(disabledRoles);
    $[10] = disabledRoles;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== isDisabled || $[13] !== menuProps || $[14] !== onSelectRoleChange || $[15] !== removeOption || $[16] !== selectedRole || $[17] !== t6 || $[18] !== t8 || $[19] !== variant) {
    t9 = <SelectRole label="Project role" roles={t6} disabledRoles={t8} variant={variant} selectedRole={selectedRole} onChange={onSelectRoleChange} link="projectRolesHelp" menuProps={menuProps} removeOption={removeOption} isDisabled={isDisabled} />;
    $[12] = isDisabled;
    $[13] = menuProps;
    $[14] = onSelectRoleChange;
    $[15] = removeOption;
    $[16] = selectedRole;
    $[17] = t6;
    $[18] = t8;
    $[19] = variant;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}